module.exports = "/images/Lojas-Virtuais.png?12378693934cb1a7530729e9932f769f";